import { useChannelTalk } from '@repo/channel-talk';
import { useWorkingPlatform } from '@repo/platform';
import { Button, Guide } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { AUTH_PATHS } from '@/lib/constants/paths';
import { useExitService } from '@/lib/hooks/use-exit-service';

const SignOutPage = () => {
  const router = useRouter();
  const { workingPlatform } = useWorkingPlatform();
  const { openChannelTalk } = useChannelTalk();
  const { exitService } = useExitService();
  const isToss = workingPlatform === 'toss';
  const descriptionDetailText = isToss ? '앱을 종료 후 다시 시도해 주세요.' : '문의해주시면 최선을 다해 문제를 해결할게요.';

  if (workingPlatform === 'web' || workingPlatform === 'app') {
    router.replace(AUTH_PATHS.로그인);
  }

  const handleClickAsk = () => {
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <>
      {workingPlatform !== 'web' && (
        <Layout
          rightTextButton={
            !isToss
              ? {
                  label: '나가기',
                  state: 'gray',
                  onClick: exitService
                }
              : undefined
          }
        >
          <div className="flex h-[calc(100vh-100px)] w-full flex-col justify-center">
            <Guide>
              <Guide.TextArea>
                <Guide.Title>{'비즈넵 환급 로그인 인증이\n만료되었어요'}</Guide.Title>
                <Guide.Description>{`이용에 불편을 드려 죄송합니다.\n${descriptionDetailText}`}</Guide.Description>
              </Guide.TextArea>
              <Guide.ButtonArea>
                <Button.Box size="large" state="basic" onClick={handleClickAsk}>
                  문의하기
                </Button.Box>
              </Guide.ButtonArea>
            </Guide>
          </div>
        </Layout>
      )}
    </>
  );
};

export default SignOutPage;
